import { render, staticRenderFns } from "./invoice_picture.vue?vue&type=template&id=13d278f6&scoped=true"
import script from "./invoice_picture.vue?vue&type=script&lang=js"
export * from "./invoice_picture.vue?vue&type=script&lang=js"
import style0 from "./invoice_picture.vue?vue&type=style&index=0&id=13d278f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d278f6",
  null
  
)

export default component.exports